import React, { useRef, useCallback, useEffect } from 'react';

export function usePolling(fn, intervalMs) {
  const timerRef = useRef();

  const start = useCallback(() => {
    // run immediately…
    fn();
    // …then every intervalMs
    timerRef.current = setInterval(fn, intervalMs);
  }, [fn, intervalMs]);

  const stop = useCallback(() => {
    clearInterval(timerRef.current);
  }, []);

  // auto-stop on unmount
  useEffect(() => () => stop(), [stop]);

  return { start, stop };
}
